import * as yup from "yup"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"

export const validationSchema = (t) => yup.object({
    password: yup
        .string()
        .required(t(I18N_NAMESPACE, "forms.loginForm.fields.password.requireMessage")),
})